import {DestroyRef, inject, Injectable} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {EVENT_BUS} from '../../../../../shared/domain/tokens/event-bus.token';
import {AccountModeService} from '../../account-modes/account-mode.service';
import {AccountModeChangedEvent} from '../../../../../shared/application/events/account/account-mode-changed.event';
import {switchMap} from "rxjs";

@Injectable({providedIn: 'root'})
export class AccountModeSubscriber {
  private readonly eventBus = inject(EVENT_BUS);
  private readonly accountMode = inject(AccountModeService);
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    this.eventBus
      .ofType(AccountModeChangedEvent)
      .pipe(
        switchMap(e => this.accountMode.insertAccountMode(e.modeType)),
        takeUntilDestroyed(this.destroyRef))
      .subscribe();
  }
}
